module.exports = __webpack_public_path__ + "677433a0892aaed7b7d2628c313c9775.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 351
// module chunks = 1